export default "__VITE_ASSET__BoMGBtdd__"